export default "__VITE_ASSET__Dl4mPS_p__"